module.exports = __webpack_public_path__ + "img/IN.eb07d627.webp";